if (!customElements.get("leve-junto-products")) {
  class LeveJuntoProducts extends HTMLElement {
    connectedCallback() {
      // clique delegado no botão de ATC — cobre tanto o conteúdo renderizado no servidor quanto o injetado via fetch
      this.addEventListener("click", (e) => {
        const button = e.target.closest("[data-levejunto-atc]");
        if (!button) return;
        e.preventDefault();
        this.addToCart(button);
      });

      // conteúdo já veio renderizado do servidor (recommendations populado na primeira carga): não busca de novo
      if (this.querySelector(".swiper-container")) {
        this.initSlider();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.loadRecommendations();
        },
        { rootMargin: "0px 0px 400px 0px" }
      );
      this.observer.observe(this);
    }

    // complementares (Search & Discovery) têm prioridade; recomendados só se não houver nenhum disponível
    loadRecommendations() {
      const tryIntent = (intent) =>
        fetch(`${this.dataset.url}&intent=${intent}`)
          .then((response) => response.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, "text/html");
            const recommendations = doc.querySelector("leve-junto-products");
            return recommendations && recommendations.innerHTML.trim().length ? recommendations.innerHTML : null;
          });

      tryIntent("complementary")
        .then((html) => html || tryIntent("related"))
        .then((html) => {
          if (html) {
            this.innerHTML = html;
            this.initSlider();
          }
        })
        .catch((err) => console.error("leve-junto fetch error:", err));
    }

    initSlider() {
      const container = this.querySelector(".swiper-container");
      if (!container) return;
      this.slider = new MinimogLibs.Swiper(container, {
        slidesPerView: 2.8,
        spaceBetween: 5,
        threshold: 2,
        // setas só aparecem no desktop (CSS), mas o módulo fica ativo nos dois
        navigation: {
          prevEl: this.querySelector(".m-pdp-levejunto__arrow--prev"),
          nextEl: this.querySelector(".m-pdp-levejunto__arrow--next"),
          disabledClass: "m-pdp-levejunto__arrow--disabled",
        },
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: 3.65,
            spaceBetween: 5,
          },
        },
      });
    }

    addToCart(button) {
      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const { MinimogSettings, MinimogStrings } = window;
      if (!MinimogSettings || typeof fetchConfig !== "function") return;
      const cartDrawer = document.querySelector("m-cart-drawer");

      // coleta as sections do carrinho pra re-render (mesmo padrão do signature-kits)
      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections } })
      );

      const config = fetchConfig("javascript");
      config.method = "POST";
      config.body = JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections,
        sections_url: window.location.pathname,
      });

      this.toggleLoading(button, true);
      fetch(`${MinimogSettings.routes.cart_add_url}`, config)
        .then((r) => r.json())
        .then((response) => {
          if (response.status) {
            document.dispatchEvent(
              new CustomEvent("product-ajax:error", { detail: { errorMessage: response.description } })
            );
            // nada escuta product-ajax:error neste tema — mostra o erro aqui mesmo
            if (window.MinimogTheme && MinimogTheme.Notification) {
              MinimogTheme.Notification.show({
                target: this,
                method: "prepend",
                type: "error",
                message: response.description,
                last: 4000,
              });
            }
            return;
          }

          if (MinimogSettings.use_ajax_atc) {
            if (cartDrawer && MinimogSettings.enable_cart_drawer) {
              // QA 2026-07-13: sem notificação de sucesso no drawer (o drawer abrir já é o feedback)
              if (typeof cartDrawer.open === "function") cartDrawer.open();
            }
            if (window.MinimogEvents && window.MinimogTheme) {
              window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: response });
            }
            document.dispatchEvent(new CustomEvent("product-ajax:added", { detail: { product: response } }));
          } else {
            window.location = MinimogSettings.routes.cart;
          }
        })
        .catch((err) => console.error("leve-junto add error:", err))
        .finally(() => this.toggleLoading(button, false));
    }

    toggleLoading(button, loading) {
      button.classList.toggle("is-loading", loading);
      if (loading) {
        button.setAttribute("aria-busy", "true");
      } else {
        button.removeAttribute("aria-busy");
      }
    }
  }

  customElements.define("leve-junto-products", LeveJuntoProducts);
}
